export default {
  loading: false,
  settings: [],
  setting: {},
  totalCount: 0,
  page:0,
};
